import { GlLink, GlIcon, GlSprintf } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { helpPagePath } from '~/helpers/help_page_helper';
export default {
    name: 'NoteableWarning',
    docsLinks: {
        locked: helpPagePath('user/discussions/_index', {
            anchor: 'prevent-comments-by-locking-the-discussion'
        }),
        confidential: helpPagePath('user/discussions/_index', {
            anchor: 'comments-on-confidential-items'
        })
    },
    components: {
        GlIcon,
        GlLink,
        GlSprintf
    },
    props: {
        isLocked: {
            type: Boolean,
            default: false,
            required: false
        },
        isConfidential: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    computed: {
        warningIcon () {
            if (this.isConfidential) return 'eye-slash';
            if (this.isLocked) return 'lock';
            return '';
        },
        isLockedAndConfidential () {
            return this.isConfidential && this.isLocked;
        }
    }
};
